// extracted by mini-css-extract-plugin
export default {"domainDisplay":"simple2C_domainDisplay__AXzsI"};